import React from 'react';
import { 
  HelpCircle, 
  TrendingUp, 
  Target, 
  ShieldCheck, 
  Globe, 
  Code, 
  Zap, 
  BarChart2 
} from 'lucide-react';

const TipsSidebar = () => {
  const aiInvestmentTips = [
    {
      icon: TrendingUp,
      title: 'Диверсификация',
      description: 'Распределяйте инвестиции между различными секторами и технологиями ИИ для снижения рисков.'
    },
    {
      icon: Target,
      title: 'Долгосрочная стратегия',
      description: 'ИИ - перспективная технология. Планируйте инвестиции с горизонтом 5-10 лет.'
    },
    {
      icon: ShieldCheck,
      title: 'Управление рисками',
      description: 'Выбирайте инвестиционную стратегию в соответствии с вашей толерантностью к риску.'
    },
    {
      icon: Globe,
      title: 'Глобальный подход',
      description: 'Рассматривайте инвестиции в ИИ из разных географических регионов.'
    },
    {
      icon: Code,
      title: 'Технологический фокус',
      description: 'Следите за прорывными технологиями: машинное обучение, нейронные сети, компьютерное зрение.'
    },
    {
      icon: Zap,
      title: 'Регулярные инвестиции',
      description: 'Используйте стратегию усредения стоимости с регулярными ежемесячными взносами.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по инвестициям в ИИ
      </h3>

      <div className="space-y-3">
        {aiInvestmentTips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <BarChart2 className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Аналитическая поддержка
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Регулярно анализируйте портфель и будьте в курсе последних тенденций в развитии ИИ.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Получить консультацию
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;